import { Grid } from "../core/components/grid.js";
import { GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar.js";
import { Helper } from "../core/util/helper.js";
import { General } from "../../siteManagement/general.js";
import { Sheet, SheetEventType } from "../../siteManagement/sheet.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { Config } from "../core/config/config.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { KeyValuePair, StringKeyDictionary } from "../commonInterfaces.js";
import React from "react";
import PartsCS from "../parts/partsCS.js";
import DefinedMachine, { DefinedMachineProps } from "./definedMachine.js";
import { Entity } from "../core/components/commonApp.js";

export default class DefinedMachinesGrid extends React.Component<any, DefinedMachinesGridState> {
    private projNr: string;
    private pIndex: number;
    private belegNr: number;
    private AdrNr: string;
    private gridContext: string;
    private translations: StringKeyDictionary<string>;
    private _topMostSheet: Sheet = null;

    constructor(props) {
        super(props);
        this.state = {
            gridData: [],
            selected: null
        }
        this.initApp();
        this._setEvents();
    }

    componentDidMount() {
        this._topMostSheet = General.Sheet.Manager.getTopMostSheet();
    }

    private _setEvents = () => {
        $(window).on("serviceReportMachinesWorkedOnChanged", (e, d) => {
            if (d.update) {
                this.loadData();
            }
        });
        $(window).on("refreshMaschinesGrid", (e, d) => {
            this.loadData();
        });
    }

    private initApp = async () => {
        this.gridContext = this.props.context.machineGrid.context;
        switch (this.gridContext) {
            case "Assigment":
                this.projNr = this.props.entity.ProjNr;
                this.pIndex = this.props.entity.PIndex;
                this.AdrNr = this.props.entity.AdrNr;
                break;
            case "ServiceReport":
            default:
                this.projNr = this.props.entity.Projnr;
                this.pIndex = this.props.entity.Pindex;
                this.AdrNr = this.props.entity.Adrnr;
                this.belegNr = this.props.entity.Belegnr;
                break;
        }

        const results = await Promise.all([
            Helper.getTranslations(["WebSMS.ServiceReport.AddMachine"]),
            this.loadData()
        ]);
        this.translations = results[0].Data;
        this.setState({});

    }

    private handleClickStandardButton = async (type: ToolBarStandardButtonType, dataItem: EntityMachine) => {
        if (type == ToolBarStandardButtonType.DELETE) {
            if (dataItem.ZugehoerigkeitId !== 0) {
                let deleteMessage = Config.translations.deleteMessage;
                let reallyDelete: boolean;
                if (this.state.selected.WorkedOnMachineCount > 0) {
                    deleteMessage = Helper.getTranslation("Maschine.Msg.WorkedOnCount").replace("{0}", this.state.selected.WorkedOnMachineCount.toString()) + "<br/><br/>" + deleteMessage;
                    reallyDelete = await DialogHelper.ask({
                        header: Helper.getTranslation("Maschine.Delete"),
                        text: deleteMessage,
                        isHtml: true,
                        canCancel: true
                    });
                } else {
                    reallyDelete = await DialogHelper.confirm(deleteMessage);
                }
                if (reallyDelete) {
                    // let additionalParams = [{Key: "PROJNR", Value: this.props.entity.ProjNr}, {Key: "PINDEX", Value: this.props.entity.PIndex}];
                    let additionalParams = {};
                    additionalParams["PROJNR"] = this.props.entity.ProjNr;
                    additionalParams["PINDEX"] = this.props.entity.PIndex;
                    const hasReferences = await HTTPService.post<JsonResultClass<boolean>>('ProjectMachine/HasMachineReferences', {machineNrs: [dataItem.MaschNr], type: 0, addParams: additionalParams});
                    if(hasReferences.Code == 0) {
                        let isOk = false;
                        if(hasReferences.Data){
                            isOk = await DialogHelper.confirm(Helper.getTranslation("WebSMS.Project.DeleteAssignedMachines"), null, Helper.getTranslation("Server.No"), Helper.getTranslation("Server.Yes"));
                        }
                        await this.editData("Delete", dataItem.MaschNr, isOk);
                    }else{
                        NotificationHelper.showErrorMessage(hasReferences.Message);
                    }
                }
            }
        } else if (type == ToolBarStandardButtonType.EDIT && this.gridContext == "ServiceReport") {
            this.editMachine(this.state.selected);
        }
    }

    private editMachine = async (entity: EntityMachine) => {
        const props: DefinedMachineProps = {
            dataSources: {
            },
            metadata: await Helper.getMetaData("serviceReportMachine"),
            entity: entity,
            isWindow: true,
            context: {
                key1: "entity.BelegNr",
                keyVal1: this.props.entity.BelegNr,
                key2: "entity.MaschNr",
                keyVal2: this.props.entity.MaschNr,
                contextType: "ServiceReportMachine"
            }
        }
        props.entity.RecordRight.CanRead = true;
        props.entity.RecordRight.CanWrite = true;
        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.SavedSuccessfully, (target) => {
            this.loadData();
        });

        sheet.show(() => {
            sheet.mountContent(DefinedMachine, props);
        });
    }

    private saveMachine = async (dataItem: EntityMachine) => {
        let result = await HTTPService.post<JsonResultClass>("Machine/SaveProjectRegardedMachine", dataItem);
        if (result.Code == 0) {
            NotificationHelper.showSuccessMessage(result.Message);
            $(window).trigger("serviceReportMachinesWorkedOnChanged", { update: true });
            this.loadData();
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private editData = async (command: "Add" | "Delete", maschNr: string, handleAssembly: boolean = false) => {
        let url: string;

        if (command == "Add") {
            url = "Machine/AddMachineToAssigment?MaschNr=" + encodeURIComponent(maschNr) + "&ProjNr=" + encodeURIComponent(this.projNr) + "&PIndex=" + encodeURIComponent(this.pIndex) + "&belegNr=" + encodeURIComponent(this.belegNr ?? 0) + "&addAssemblyTree=" + encodeURIComponent(handleAssembly);
        } else if (command == "Delete") {
            url = "Machine/DeleteMachinesFromAssigment?MaschNr=" + encodeURIComponent(maschNr) + "&ProjNr=" + encodeURIComponent(this.projNr) + "&PIndex=" + encodeURIComponent(this.pIndex) + "&removeAssemblyTree=" + encodeURIComponent(handleAssembly);
        }

        const result = await HTTPService.post<JsonResultClass>(url);
        if (result.Code > 0) {
            NotificationHelper.showErrorMessage(result.Message);
        } else {
            await this.loadData();
            this.triggerRefreshSendState();
        }
    }

    private triggerRefreshSendState = () => {
        this._topMostSheet.trigger(SheetEventType.Custom, { command: "refreshSendState" });
    }

    private handleClickCustomButton = (id: string) => {
        if (id == "addMachine") {
            this.getNewMachine();
        }
    }

    private getNewMachine = () => {
        const sheet = General.Sheet.Manager.createSheetWithUrl(`DynamicSearch/Window/Machine?multi=false&cus_Limited=true&adrnr=${encodeURIComponent(this.AdrNr)}&cus_projnr=${encodeURIComponent(this.projNr)}&cus_pindex=${this.pIndex}`, null, { disableTabTitle: true });
        sheet.bind(SheetEventType.RowClicked, async (data) => {
            // let additionalParams: KeyValuePair[] = [{Key: "PROJNR", Value: this.props.entity.ProjNr}, {Key: "PINDEX", Value: this.props.entity.PIndex}];
            let additionalParams = {};
            additionalParams["PROJNR"] = this.props.entity.ProjNr;
            additionalParams["PINDEX"] = this.props.entity.PIndex;
            const hasReferences = await HTTPService.post<JsonResultClass<boolean>>('ProjectMachine/HasMachineReferences', {machineNrs: [data], addParams: null});
            if(hasReferences.Code == 0) {
                let isOk = false;
                if(hasReferences.Data) {
                    isOk = await DialogHelper.confirm(Helper.getTranslation("WebSMS.Project.AddAssignedMachines"), null, Helper.getTranslation("Server.No"), Helper.getTranslation("Server.Yes"))
                }
                this.editData("Add", data, isOk);
            }else{
                NotificationHelper.showErrorMessage(hasReferences.Message);
            }
        });
    }

    private loadData = async () => {
        let url = "Machine/GetProjectRegardedMachines?projNr=" + encodeURIComponent(this.projNr) + "&Pindex=" + this.pIndex;
        if (this.gridContext == "ServiceReport")
            url += "&belegNr=" + this.belegNr;
        const result = await HTTPService.get<JsonResultClass<EntityMachine[]>>(url);
        if (result.Code == 0) {
            const data = result.Data.map(this.map);
            this.setState({ gridData: data });
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private map = (item): EntityMachine => {
        return {
            MaschNr: item.MaschNr,
            MaschNr2: item.Maschnr2,
            Maschtyp: item.Maschtyp,
            InstallTermin: Helper.dates.toString(Helper.dates.toDate(item.Installtermin)),
            Maschbezeichnung: item.MaschBezeichnung,
            AddedByTech: null,
            Zugehoerigkeit: item.Zugehoerigkeit,
            ZugehoerigkeitId: item.ZugehoerigkeitId,
            BelegNr: item.BelegNr,
            WorkedOnMachine: item.WorkedOnMachine,
            WorkedOnMachineCount: item.WorkedOnMachineCount,
            Text: item.Text,
            IndividualFields: item.IndividualFields,
            IndividualFieldsLbmaschind: item.IndividualFieldsLbmaschind,
            IsNew: item.IsNew,
            IsWatchable: item.IsWatchable,
            IsWatched: item.IsWatched,
            RecordRight: item.RecordRight
        };
    }

    private canWrite = (): boolean => {
        const readOnly = this.props.readOnly ? this.props.handleEval(this.props.readOnly) : false;
        return this.props.entity.RecordRight.CanWrite && !readOnly;
    }

    handleDataBound = (e) => {
        var data = e.sender.dataSource.view();
        for (var i = 0; i < data.length; i++) {
            if (data[i].ZugehoerigkeitId == 0) {
                var row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
                if (!Config.user.isExternal) {
                    $(row).css("background-color", "#e0e0e0");
                    $(row).css("color", "#333");
                }   
            }
        }
    }

    private onRowDataBound = (e: HTMLElement, dataItem: EntityMachine) => {
        if (this.canWrite())
            e.onclick = (ev) => this.handleOnClick(ev, dataItem);
    }

    private handleOnClick = async (ev: MouseEvent, dataItem: EntityMachine) => {
        const $target = $(ev.target);
        let $div = $target.closest("div");
        if ($div == undefined)
            return;
        if ($div.data("action") === "add-project-maschine") {
            this.editData("Add", dataItem.MaschNr);
        } else if ($div.data("action") === "remove-project-maschine") {
            let reallyDelete = true;
            if (dataItem.WorkedOnMachineCount > 0) {
                var deleteMessage = Helper.getTranslation("Maschine.Msg.WorkedOnCount").replace("{0}", dataItem.WorkedOnMachineCount.toString()) + "<br/><br/>" + Config.translations.deleteMessage;
                reallyDelete = await DialogHelper.confirm(deleteMessage);
            }
            if (reallyDelete) {
                await this.editData("Delete", dataItem.MaschNr);
            }
        }
    }

    private renderGrid = () => {
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({
            type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel,
            enabled: this.canWrite() && (this.state.selected != null && this.state.selected.ZugehoerigkeitId !== 0)
        });

        if (this.gridContext == "ServiceReport") {
            standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: this.canWrite() && this.state.selected != null });
        }

        const customButtons: Array<GridCustomToolBarButton> = [];
        customButtons.push({ id: "addMachine", autoEnabledOnRecordSelected: false, iconClass: "k-i-seek-s", caption: this.translations["WebSMS.ServiceReport.AddMachine"], enabled: this.canWrite() });
        return (
            <>
                <Grid
                    id="MachinesForAssigment"
                    data={this.state.gridData}
                    options={this.props.context.machineGrid}
                    onSelectionChanged={(dataItem) => { this.setState({ selected: dataItem }) }}
                    standardButtons={standardButtons}
                    onClickStandardButton={this.handleClickStandardButton}
                    customButtons={customButtons}
                    onClickCustomButton={this.handleClickCustomButton}
                    onDataBound={this.handleDataBound}
                    rowDataBound={this.onRowDataBound}>
                </Grid>
            </>
        );
    }

    render() {
        return Helper.hasValue(this.translations) ? this.renderGrid() : null;
    }
}

export interface EntityMachine extends Entity {
    MaschNr: string;
    MaschNr2: string;
    Maschbezeichnung: string;
    Maschtyp: string;
    InstallTermin: string;
    AddedByTech: string;
    Zugehoerigkeit: string;
    ZugehoerigkeitId: number;
    IndividualFields?: any;
    BelegNr?: number;
    WorkedOnMachine?: boolean;
    WorkedOnMachineCount?: number;
    Text?: string;
    IndividualFieldsLbmaschind?: any;
}

interface DefinedMachinesGridState {
    gridData: EntityMachine[];
    selected: EntityMachine;
}